import React, { CSSProperties, FC, Ref } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon';
require("./Delivery.css");
var styles = {
  "Root": "Delivery-module-Root_swx",
  "Text": "Delivery-module-Text_2nF",
  "notAvailableVariant": "Delivery-module-notAvailableVariant_3fK",
  "pickupVariant": "Delivery-module-pickupVariant_hp9",
  "prescriptionOnlyVariant": "Delivery-module-prescriptionOnlyVariant_33d",
  "quickVariant": "Delivery-module-quickVariant_2wU",
  "Icon": "Delivery-module-Icon_1_r"
};
export const DeliveryVariants = {
  byDate: 'byDate',
  quick: 'quick',
  notAvailable: 'notAvailable',
  pickup: 'pickup',
  prescriptionOnly: 'prescriptionOnly'
};
export const Delivery = ({
  date,
  variant = DeliveryVariants.quick,
  style,
  innerRef,
  controlRef,
  className
}) => {
  const getMessage = () => {
    const defaultMessage = 'Доставка недоступна';
    switch (variant) {
      case DeliveryVariants.byDate:
        return date ? `Доставим ${date}` : defaultMessage;
      case DeliveryVariants.quick:
        return 'Быстрая доставка';
      case DeliveryVariants.notAvailable:
        return 'Нет в наличии';
      case DeliveryVariants.pickup:
        return 'Только самовывоз';
      case DeliveryVariants.prescriptionOnly:
        return 'Строго по рецепту';
      default:
        return defaultMessage;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${variant}Variant`], className),
    style: style
  }, variant === 'quick' && /*#__PURE__*/React.createElement(Icon, {
    name: "lightning",
    className: styles.Icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.Text
  }, getMessage()));
};
if (process.env.NODE_ENV !== 'production') {
  Delivery.displayName = 'Delivery';
}